var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#366EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13184 10.1973C7.14095 9.65495 7.20247 9.22656 7.31641 8.91211C7.43034 8.59766 7.66276 8.24902 8.01367 7.86621L8.90918 6.94336C9.29199 6.51042 9.4834 6.04557 9.4834 5.54883C9.4834 5.07031 9.35807 4.69661 9.10742 4.42773C8.85677 4.1543 8.49219 4.01758 8.01367 4.01758C7.54883 4.01758 7.17513 4.14062 6.89258 4.38672C6.61003 4.63281 6.46875 4.96322 6.46875 5.37793H5.2041C5.21322 4.63965 5.47526 4.04492 5.99023 3.59375C6.50977 3.13802 7.18424 2.91016 8.01367 2.91016C8.875 2.91016 9.54492 3.14258 10.0234 3.60742C10.5065 4.06771 10.748 4.70117 10.748 5.50781C10.748 6.30534 10.3789 7.09147 9.64062 7.86621L8.89551 8.60449C8.56283 8.97363 8.39648 9.50456 8.39648 10.1973H7.13184ZM7.07715 12.3643C7.07715 12.1592 7.13867 11.9883 7.26172 11.8516C7.38932 11.7103 7.57617 11.6396 7.82227 11.6396C8.06836 11.6396 8.25521 11.7103 8.38281 11.8516C8.51042 11.9883 8.57422 12.1592 8.57422 12.3643C8.57422 12.5693 8.51042 12.7402 8.38281 12.877C8.25521 13.0091 8.06836 13.0752 7.82227 13.0752C7.57617 13.0752 7.38932 13.0091 7.26172 12.877C7.13867 12.7402 7.07715 12.5693 7.07715 12.3643Z",
    fill: "#366EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.9c9deedcf6e4529f20c17702bf4c52c4.svg";
export { ForwardRef as ReactComponent };